import { withSentry } from '../../modules/sentry';
import $dom from 'cash-dom';
import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
import {
  globalStorePlugin,
  globalEventBusPlugin
} from '@pixelcabin/ui-utils/lib/vue';

import coffeeToggle from '../../modules/coffee_toggle';
import machineCloserLook from '../../modules/machine_closer_look';
import productVideo from '../../modules/product_video';
import machineSelector from '../../modules/machine_selector';
import pdpCarousel from '../../modules/pdp_carousel';
import PurchaseForm from '../../components/PurchaseForm/PurchaseForm.vue';
import socialShare from '../../modules/social_share';

import {
  purchaseForm,
  purchaseFormStore
} from '../../components/PurchaseForm/store';

$dom.fn.ready(
  withSentry(() => {
    console.log('init product scripts');
    coffeeToggle();
    machineCloserLook();
    productVideo();
    machineSelector();
    pdpCarousel();
    socialShare();

    Vue.use(vueCustomElement);
    Vue.use(globalEventBusPlugin);

    try {
      Vue.use(globalStorePlugin, [[purchaseForm, purchaseFormStore]]);
    } catch (err) {
      console.warn(err);
    }

    Vue.customElement('pxl-purchase-form', PurchaseForm);
  })
);
